import { externalAccountDetailsSchema } from "@clipboard-health/contract-payment-service";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { type UseQueryResult } from "@tanstack/react-query";
import z from "zod";

const getExternalAccountsResponseSchema = z.object({
  data: z.array(externalAccountDetailsSchema),
});

type GetExternalAccountsResponse = z.infer<typeof getExternalAccountsResponseSchema>;

export function useGetExternalAccounts(
  options: UseGetQueryOptions<GetExternalAccountsResponse> = {}
): UseQueryResult<GetExternalAccountsResponse> {
  const worker = useDefinedWorker();

  return useGetQuery({
    url: `${environmentConfig.REACT_APP_PAYMENTS_API_URL}/accounts/${worker.userId}/external-accounts`,
    responseSchema: getExternalAccountsResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.PAYOUT_SETTINGS_GET_EXTERNAL_ACCOUNTS_FAILURE,
    },
    ...options,
  });
}
